import { useTranslation } from "react-i18next";
import { EnrolledBeneficiaryType } from "@/types/beneficiaries";
import { formatGoalDescription } from "@/utils/generalUtilities";
import SavingsCard from "@/components/Common/Cards/SavingsCard";
import ProgressCard from "@/components/Common/Cards/ProgressCard";

interface BeneficiaryOverviewProps {
  beneficiary: EnrolledBeneficiaryType;
  calculations: {
    goalProgress: string;
  };
}

const BeneficiaryOverview = ({
  beneficiary,
  calculations,
}: BeneficiaryOverviewProps) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-5">
      <SavingsCard
        title={t("home.beneficiary_card.total_savings")}
        amount={beneficiary.marketValueAsOfDate || 0}
      />
      <ProgressCard
        headerOne="Goal: "
        headerOneDesc={formatGoalDescription(beneficiary.goal || "")}
        headerTwo="Goal Progress: "
        headerTwoDesc={`${calculations.goalProgress}%`}
        current={beneficiary.actualEmployeeContribution || 0}
        target={beneficiary.amountRequired || 0}
        percentage={calculations.goalProgress}
        className="lg:col-span-2"
        showTooltip
        tooltipText="You can change your savings purpose anytime from Savings Settings → Goals."
      />
    </div>
  );
};

export default BeneficiaryOverview;
